import { PlateConsult } from "models/PlateConsult";
import { BaseServices } from "./baseServices";

export interface PlateConsultResponse {
	tag: string;
	empresa: string;
	situacao: string;
}

export interface PlateConsultRequest {
	placa: string;
}

export class PlateConsultService extends BaseServices<PlateConsultResponse, PlateConsult> {
	static instance = new PlateConsultService();

	static readonly baseEndpoint = "/license-plate";

	constructor() {
		super(PlateConsult);
	}

	async consultPlateMock(placa: string): Promise<PlateConsult[]> {
		const url = `${PlateConsultService.baseEndpoint}/mock`;
		const requestData: PlateConsultRequest = { placa };

		const responseData = await this.post(url, requestData);

		return this.createResourcesFromListResponse(responseData ?? []);
	}

	async consultPlate(placa: string): Promise<PlateConsult[]> {
		const url = `${PlateConsultService.baseEndpoint}`;
		const requestData: PlateConsultRequest = { placa };

		const responseData = await this.post(url, requestData);

		const resources = this.createResourcesFromListResponse(responseData ?? []);

		const filteredResources = resources.filter((r) => !(r.tag === "N/A" || r.empresa === "Desconhecida" || r.situacao === "nao-encontrado"));

		return filteredResources;
	}

	async consultPlateRaw(placa: string): Promise<PlateConsultResponse[]> {
		const url = `${PlateConsultService.baseEndpoint}/mock`;
		const requestData: PlateConsultRequest = { placa };

		const responseData = await this.post(url, requestData);

		return responseData ?? [];
	}

	createResourcesFromListResponse(results: PlateConsultResponse[]): PlateConsult[] {
		return (results ?? []).map((data) => PlateConsult.createFromResponse(data));
	}

	static getInstance() {
		return PlateConsultService.instance;
	}
}
